module.exports = __webpack_public_path__ + "static/media/user.c1a51bd2.svg";